var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4816 2.54541H0.518475C0.232925 2.54541 0 2.77835 0 3.06389V3.58237C0 3.71977 0.0547465 3.85181 0.152432 3.94948C0.249042 4.0461 0.381078 4.10084 0.518472 4.10084H1.03695V16.0269C1.03695 16.1643 1.09169 16.2964 1.18938 16.393C1.28599 16.4907 1.41803 16.5454 1.55542 16.5454H12.4446C12.582 16.5454 12.714 16.4907 12.8106 16.393C12.9083 16.2964 12.9631 16.1643 12.9631 16.0269V4.10084H13.4815C13.6189 4.10084 13.751 4.0461 13.8476 3.94948C13.9453 3.8518 14 3.71976 14 3.58237V3.06389C14 2.92649 13.9453 2.79445 13.8476 2.69785C13.751 2.60016 13.619 2.54541 13.4816 2.54541ZM11.4077 14.9901H2.59246V4.10082H11.4077V14.9901Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09095 5.72723H5.72732C6.07911 5.72723 6.36368 6.00867 6.36368 6.23633V12.8545C6.36368 13.1359 6.07909 13.3636 5.72732 13.3636H5.09095C4.73916 13.3636 4.45459 13.0822 4.45459 12.8545V6.23633C4.45459 5.95489 4.73918 5.72723 5.09095 5.72723Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27308 5.72723H8.90945C9.26124 5.72723 9.54581 6.00867 9.54581 6.23633V12.8545C9.54581 13.1359 9.26122 13.3636 8.90945 13.3636H8.27308C7.92129 13.3636 7.63672 13.0822 7.63672 12.8545V6.23633C7.63672 5.95489 7.92131 5.72723 8.27308 5.72723Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34818 0H9.6512C9.94437 0 10.1815 0.351793 10.1815 0.636363V1.27273C10.1815 1.62452 9.94435 1.90909 9.6512 1.90909H4.34818C4.05501 1.90909 3.81787 1.5573 3.81787 1.27273V0.636363C3.81787 0.284571 4.05503 0 4.34818 0Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFile);
export default __webpack_public_path__ + "static/media/remove-file.1782270753521152b4cfc164c03bec62.svg";
export { ForwardRef as ReactComponent };